// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import { setSEO } from '@/utils/seo'

// 懒加载组件（推荐）
const Home = () => import('@/views/Home.vue')
const MyHome = () => import('@/views/MyHome.vue')
const Lounges = () => import('@/views/Lounges.vue')
const LoungeDetail = () => import('@/views/LoungeDetail.vue')
const Login = () => import('@/views/auth/Login.vue')
const Register = () => import('@/views/auth/Register.vue')
const Booking = () => import('@/views/Booking.vue')
const OrderDetail = () => import('@/views/OrderDetail.vue')
const OrderList = () => import('@/views/OrderList.vue')
const MyOrders = () => import('@/views/MyOrders.vue')
const Reviews = () => import('@/views/Reviews.vue')

const routes = [
  {
    path: '/',
    name: 'myhome',
    component: MyHome,
    meta: {
      title: '首页',
      description: '珠海启程商旅服务有限公司 - 航空贵宾厅预约系统首页，浏览热门贵宾厅服务。航空贵宾预约，选择启程商旅。',
      keywords: '珠海启程商旅服务有限公司,启程商旅,航空贵宾预约,航空贵宾厅预约,机场VIP,贵宾厅预约,航空贵宾厅'
    }
  },
  {
    path: '/home',
    name: 'home',
    component: Home,
    meta: {
      title: '首页',
      description: '珠海启程商旅服务有限公司 - 航空贵宾厅预约系统首页，浏览热门贵宾厅服务。航空贵宾预约，选择启程商旅。',
      keywords: '珠海启程商旅服务有限公司,启程商旅,航空贵宾预约,航空贵宾厅预约,机场VIP,贵宾厅预约,航空贵宾厅'
    }
  },
  {
    path: '/lounges',
    name: 'lounges',
    component: Lounges,
    meta: {
      title: '贵宾厅列表 - 珠海启程商旅服务有限公司',
      description: '珠海启程商旅服务有限公司提供全国主要机场贵宾厅服务，选择最适合您的贵宾厅。航空贵宾预约，选择启程商旅。',
      keywords: '珠海启程商旅服务有限公司,启程商旅,航空贵宾预约,贵宾厅列表,机场贵宾厅,贵宾厅预订,航空贵宾厅预约'
    }
  },
  {
    path: '/lounge/:id',
    name: 'lounge-detail',
    component: LoungeDetail,
    meta: {
      title: '贵宾厅详情 - 珠海启程商旅服务有限公司',
      description: '珠海启程商旅服务有限公司提供贵宾厅详细信息，包括服务内容、价格、评价等。航空贵宾预约，选择启程商旅。',
      keywords: '珠海启程商旅服务有限公司,启程商旅,航空贵宾预约,贵宾厅详情,贵宾厅介绍,贵宾厅预订,航空贵宾厅预约'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      showHeader: false,
      title: '登录',
      description: '登录航空贵宾厅预约系统',
      keywords: '登录,用户登录'
    }
  },
  {
    path: '/register',
    name: 'register',
    component: Register,
    meta: {
      showHeader: false,
      title: '注册',
      description: '注册航空贵宾厅预约系统账号',
      keywords: '注册,用户注册'
    }
  },
  {
    path: '/booking/:loungeId',
    name: 'booking',
    component: Booking,
    meta: {
      title: '预订贵宾厅 - 珠海启程商旅服务有限公司',
      description: '珠海启程商旅服务有限公司提供航空贵宾厅预订服务。航空贵宾预约，选择启程商旅。',
      keywords: '珠海启程商旅服务有限公司,启程商旅,航空贵宾预约,预订,贵宾厅预订,航空贵宾厅预约'
    }
  },
  {
    path: '/order-detail/:id',
    name: 'order-detail',
    component: OrderDetail,
    meta: {
      title: '订单详情 - 珠海启程商旅服务有限公司',
      description: '珠海启程商旅服务有限公司订单详情查询。航空贵宾预约，选择启程商旅。',
      keywords: '珠海启程商旅服务有限公司,启程商旅,航空贵宾预约,订单详情,订单查询'
    }
  },
  {
    path: '/order-list',
    name: 'order-list',
    component: OrderList,
    meta: {
      title: '订单列表 - 珠海启程商旅服务有限公司',
      description: '珠海启程商旅服务有限公司订单列表查询。航空贵宾预约，选择启程商旅。',
      keywords: '珠海启程商旅服务有限公司,启程商旅,航空贵宾预约,订单列表,我的订单'
    }
  },
  {
    path: '/my-orders',
    name: 'my-orders',
    component: MyOrders,
    meta: {
      title: '我的订单 - 珠海启程商旅服务有限公司',
      description: '珠海启程商旅服务有限公司 - 查看我的订单列表。航空贵宾预约，选择启程商旅。',
      keywords: '珠海启程商旅服务有限公司,启程商旅,航空贵宾预约,我的订单,订单管理'
    }
  },
  {
    path: '/reviews',
    name: 'reviews',
    component: Reviews,
    meta: {
      title: '用户评价 - 珠海启程商旅服务有限公司',
      description: '查看用户对珠海启程商旅服务有限公司贵宾厅服务的评价。航空贵宾预约，选择启程商旅。',
      keywords: '珠海启程商旅服务有限公司,启程商旅,航空贵宾预约,用户评价,评价,评论'
    }
  }
]

const router = createRouter({
  history: createWebHistory(), // 对应 Vue 2 的 mode: 'history'
  base: '/', // 可选，一般不需要
  routes
})

// 路由守卫：设置 SEO
router.afterEach((to) => {
  const meta = to.meta || {}
  const baseUrl = 'https://www.qchsvip.cn'
  
  setSEO({
    title: meta.title || '航空贵宾厅预约系统',
    description: meta.description || '专业的航空贵宾厅预约服务，为您提供舒适的候机体验',
    keywords: meta.keywords || '航空贵宾厅,机场VIP,贵宾厅预约',
    url: `${baseUrl}${to.fullPath}`,
    type: meta.type || 'website'
  })
})

export default router